<header>
    <div class="outbound-wrapper">
        <div>
            <ul>
                <li>
                    <a href="https://entreprise.coriolis.com/" class="enterprise" target="_blank">Pour les pros</a>
                </li>
                <li>
                    <a href="https://assistance.coriolis.com/" class="stores" target="_blank">Joindre un conseiller</a>
                </li>
            </ul>
        </div>
    </div>

    <div class="header-content">

        <div class="header-content-wrapper">
            <span class="logo">&nbsp;</span>
        </div>

    </div>

</header>
